export const handleMousedown = (e: any) => {
  e = e || window.event;

  e.nativeEvent.stopImmediatePropagation();
  e.stopPropagation();
  e.preventDefault();
  // 获取当前节点的父级元素
  let drag = e.target.parentElement;
  if (drag.style.right) {
    drag.style.left =
      document.body.clientWidth -
      parseInt(drag.style.right) -
      drag.offsetWidth +
      'px';
  }
  drag.style.right = '';
  // 点关闭按钮不能拖拽模态框
  if (e.target.getAttribute('class') === 'atk-close') {
    return;
  }
  // 获取偏移量
  let diffX = e.clientX - drag.offsetLeft;
  let diffY = e.clientY - drag.offsetTop;
  // 鼠标拖动事件
  function fnMove(e: any) {
    e = e || window.event;
    let left = e.clientX - diffX;
    let top = e.clientY - diffY;
    if (left < 0) {
      left = 0;
    } else if (left > window.innerWidth - drag.innerWidth) {
      left = window.innerWidth - drag.innerWidth;
    }
    if (top < 0) {
      top = 0;
    } else if (top > window.innerHeight - drag.innerHeight) {
      top = window.innerHeight - drag.innerHeight;
    }
    drag.style.left = left + 'px';
    drag.style.top = top + 'px';
  }
  // 移除事件
  function fnEnd() {
    drag.style.zIndex = '';

    document.removeEventListener('mousemove', fnMove, false);
    document.removeEventListener('mouseup', fnEnd, false);
  }
  document.addEventListener('mousemove', fnMove, false);
  document.addEventListener('mouseup', fnEnd, false);
};
export const handleResize = (e: any) => {
  console.log(e);
  e = e || window.event;
  let drag = e.target.parentNode;
  let rise = {
    y: e.clientY,
    x: e.clientX,
    w: drag.offsetWidth,
    h: drag.offsetHeight,
  };
  if (drag.style.right) {
    drag.style.left =
      document.body.clientWidth - parseInt(drag.style.right) - rise.w + 'px';
  }
  drag.style.right = '';
  // 拖动时禁止用户选择
  document.body.style.userSelect = 'none';
  function fnMove1(e: any) {
    console.log(e);
    e = e || window.event;
    let poorx = e.clientX - rise.x;
    let poory = e.clientY - rise.y;
    drag.style.width = rise.w + poorx + 'px';
    drag.style.height = rise.h + poory + 'px';
    console.log(drag.style.width, 'widthheight', drag.style.height);
  }
  // 移除事件
  function fnEnd1() {
    document.removeEventListener('mousemove', fnMove1, false);
    document.removeEventListener('mouseup', fnEnd1, false);
    document.body.style.userSelect = '';
  }
  document.addEventListener('mousemove', fnMove1, false);
  document.addEventListener('mouseup', fnEnd1, false);
};
export const handleResize1 = (e: any) => {
  e = e || window.event;
  let drag = e.target.parentNode;
  let rise = {
    y: e.clientY,
    x: e.clientX,
    w: drag.offsetWidth,
    h: drag.offsetHeight,
  };

  if (drag.style.left)
    drag.style.right =
      document.body.clientWidth - parseInt(drag.style.left) - rise.w + 'px';
  drag.style.left = '';

  // 拖动时禁止用户选择
  document.body.style.userSelect = 'none';
  function fnMove2(e: any) {
    e = e || window.event;
    let poorx = rise.x - e.clientX;
    let poory = e.clientY - rise.y;
    drag.style.width = rise.w + poorx + 'px';
    drag.style.height = rise.h + poory + 'px';
  }
  // 移除事件
  function fnEnd2() {
    document.removeEventListener('mousemove', fnMove2, false);
    document.removeEventListener('mouseup', fnEnd2, false);
    document.body.style.userSelect = '';
  }
  document.addEventListener('mousemove', fnMove2, false);
  document.addEventListener('mouseup', fnEnd2, false);
};